import 'bootstrap/dist/css/bootstrap.min.css';
import '../css/tokens.css';
import { FunctionComponent, useEffect } from 'react';
import { connect } from 'react-redux';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { loadUser } from '../actions/authActions';
import { createTheme, ThemeProvider } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import { esES } from '@mui/material/locale';
import { AuthState } from '../reducers/types';
import { AppState } from '../store';
import { vdrThemeOptions } from '../theme/vdrTheme';
import NotFoundPage from '../pages/NotFoundPage';
import PublicPage from '../pages/publicPages/PublicPage';
import PrivatePage from '../pages/privatePages/PrivatePage';
import ChatBot from './Chatbot';
import '../css/AppHome.css';

const theme = createTheme(vdrThemeOptions, esES);

type Props = {
  auth: AuthState;
  loadUser: () => Promise<void>;
};

const App: FunctionComponent<Props> = ({ auth, loadUser }) => {
  useEffect(() => {
    loadUser();
  }, [loadUser]);

  return (
    <div className='app-container' id='app'>
      <ToastContainer theme='colored' position='top-left' />
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route
              path='/*'
              element={auth.isAuthenticated ? <Navigate to='/private' /> : <PublicPage />}
            />

            <Route
              path='/public/*'
              element={auth.isAuthenticated ? <Navigate to='/private' /> : <PublicPage />}
            />

            <Route
              path='/private/*'
              element={
                auth.isAuthenticated ? <PrivatePage auth={auth} /> : <Navigate to='/public/login' />
              }
            />

            <Route path='*' element={<NotFoundPage />} />
          </Routes>
          {/* <ChatBot auth={auth} /> */}
        </Router>
      </ThemeProvider>
    </div>
  );
};

export default connect(({ auth }: AppState) => ({ auth }), { loadUser })(App);
